import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TotalFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TOTAL' htmlFor='producto-adicional-input-total' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='total'>
          {({ field }) => (
            <Form.InputNumber {...field} disabled isInvalid={iTouched && iError} id='producto-adicional-input-total' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TotalFormGroup)
